import { RoutePath } from './constants/route-constants';
import { defaultCookieExpireMinutes } from './util/cookie-util';
import { getContextPath } from './util/router-util';

const origin = window.location.origin;
const pathname = window.location.pathname;

const REACT_APP_NODE_ENV = window.REACT_APP_NODE_ENV || 'local';
const REACT_APP_CONEXT_PATHS = window.REACT_APP_CONEXT_PATHS || [''];
const REACT_APP_CONTEXT_PATH = window.REACT_APP_CONTEXT_PATH || getContextPath(pathname, REACT_APP_CONEXT_PATHS);
const REACT_APP_INSTANCE = window.REACT_APP_INSTANCE || 'custlogin.pp.gm.com';
const REACT_APP_TENANT = window.REACT_APP_TENANT || 'gmb2ctest.onmicrosoft.com';
const REACT_APP_SIGN_IN_POLICY = window.REACT_APP_SIGN_IN_POLICY || 'B2C_1A_SEAMLESSMIGRATION_SIGNUPORSIGNIN';
const REACT_APP_CLIENT_ID = window.REACT_APP_CLIENT_ID || '8fe2d0b9-ea29-4505-8832-a492af1b46f9';
const REACT_APP_REDIRECT_URI =
  window.REACT_APP_REDIRECT_URI || `${origin}${REACT_APP_CONTEXT_PATH}${RoutePath.eligibleVehicle}`;
const REACT_APP_TOKEN_REDIRECT =
  window.REACT_APP_TOKEN_REDIRECT || `${origin}${REACT_APP_CONTEXT_PATH}${RoutePath.eligibleVehicle}`;
const REACT_APP_LOGIN_CHANNELS = window.REACT_APP_LOGIN_CHANNELS || new Set(['buick', 'cadillac', 'chevrolet', 'gmc']);
const REACT_APP_SUBSCRIBER_URI = window.REACT_APP_SUBSCRIBER_URI || '';
const REACT_APP_SUBSCRIBER_CTX = window.REACT_APP_SUBSCRIBER_CTX || 'onp/consent/v1/subscriber/partnerApps';
const REACT_APP_SUBSCRIBER_GET_VEHS = window.REACT_APP_SUBSCRIBER_GET_VEHS || 'eligibleVehicleServices';
const REACT_APP_SUBSCRIBER_PUT_CONSENT = window.REACT_APP_SUBSCRIBER_PUT_CONSENT || 'consents';
const REACT_APP_LOCAL_TOKEN_URL =
  window.REACT_APP_LOCAL_TOKEN_URL || 'http://onp-consent-subscriber-authz.localhost/api/v1/oauth/test_token';
const REACT_APP_MSAL_LOG_LEVEL = window.REACT_APP_MSAL_LOG_LEVEL || 'Verbose';
const REACT_APP_FALLBACK_LOCALE = window.REACT_APP_FALLBACK_LOCALE || 'en-US';
const REACT_APP_LOCALES =
  window.REACT_APP_LOCALES ||
  'en-US,en-CA,en-GB,bg-BG,cs-CS,da-DK,de-DE,el-GR,es-ES,es-MX,et-ET,fi-FI,fr-CA,fr-FR,hu-HU,it-IT,lt-LT,lv-LV,nl-NL,no-NO,pl-PL,pt-PT,ro-RO,sk-SK,sl-SL,sv-SE,zh-CN';
const REACT_COOKIE_EXPIRE_IN_MINUTES = window.REACT_COOKIE_EXPIRE || defaultCookieExpireMinutes;
const REACT_APP_SKIP_LOGIN = window.REACT_APP_SKIP_LOGIN || false; // Turn off when doing tests

export {
  REACT_APP_NODE_ENV,
  REACT_APP_CONTEXT_PATH,
  REACT_APP_INSTANCE,
  REACT_APP_TENANT,
  REACT_APP_SIGN_IN_POLICY,
  REACT_APP_CLIENT_ID,
  REACT_APP_REDIRECT_URI,
  REACT_APP_LOGIN_CHANNELS,
  REACT_APP_SUBSCRIBER_URI,
  REACT_APP_SUBSCRIBER_CTX,
  REACT_APP_SUBSCRIBER_GET_VEHS,
  REACT_APP_SUBSCRIBER_PUT_CONSENT,
  REACT_APP_TOKEN_REDIRECT,
  REACT_APP_LOCAL_TOKEN_URL,
  REACT_APP_MSAL_LOG_LEVEL,
  REACT_APP_FALLBACK_LOCALE,
  REACT_APP_LOCALES,
  REACT_COOKIE_EXPIRE_IN_MINUTES,
  REACT_APP_SKIP_LOGIN,
};
